/* eslint-disable import/prefer-default-export */

/**
 * @param {any} state
 * @returns {bool}
 */
export const isProfessorSelector = state =>
  /instructor|professor/i.test(state.user.data.role);
